import { render, staticRenderFns } from "./ShopSellerList.vue?vue&type=template&id=59f92148&"
import script from "./ShopSellerList.vue?vue&type=script&lang=ts&"
export * from "./ShopSellerList.vue?vue&type=script&lang=ts&"
import style0 from "./ShopSellerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports